// The tab segments, shared by the route table and by the tab bar, so a rename moves
// both at once. Declared in the order they are shown.
export enum KbTab {
  SUMMARY = 'summary',
  GAPS = 'gaps',
}
